import { isIOS, isMobile, isTablet } from "react-device-detect";

export default function handleOrientationChange() {
  var _iframe = document.getElementById("neGameClient");
  _iframe.height = "100%";
  var height = Math.max(
    _iframe.scrollHeight,
    _iframe.offsetHeight,
    _iframe.clientHeight,
    _iframe.scrollHeight,
    _iframe.offsetHeight
  );
  /* var is_apple = navigator.vendor && navigator.vendor.indexOf("Apple") > -1; */
  var is_iphone = navigator.userAgent && navigator.userAgent.match(/iPhone/i);
  var is_chrome = navigator.userAgent && navigator.userAgent.match("CriOS");
  var is_portrait = window.matchMedia("(orientation: portrait)").matches;
  var is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

  //apple
  if (isIOS) {
    //iphone
    if (is_iphone) {
      //Chrome UA on iPhone
      if (is_chrome) {
        if (!is_portrait) {
          _iframe.contentWindow.postMessage(
            {
              type: "resize",
              width: window.innerWidth,
              height: height,
            },
            "*"
          );
        } else {
          _iframe.contentWindow.postMessage(
            {
              type: "resize",
              width: window.innerWidth,
              height: height,
            },
            "*"
          );
        }
      } else {
        if (!is_portrait) {
          //land
          _iframe.contentWindow.postMessage(
            {
              type: "resize",
              width: window.innerHeight,
              height: window.innerWidth - 70, //  +160
            },
            "*"
          );

          console.log(
            "resize port w " + window.innerHeight + " h " + window.innerWidth
          );
        } else {
          _iframe.contentWindow.postMessage(
            {
              type: "resize",
              width: window.innerHeight,
              height: window.innerWidth - 70, // -70
            },
            "*"
          );

          console.log(
            "resize land w " + window.innerHeight + " h " + window.innerWidth
          );
        }
      }
    } else {
      //Ipad
      if (is_safari) {
        //safary
        _iframe.contentWindow.postMessage(
          {
            type: "resize",
            width: height,
            height: window.innerWidth - 70,
          },
          "*"
        );
        console.log("resize w " + height + " h " + (window.innerWidth - 70));
      } else {
        //chrome ipad
        if (!is_portrait) {
          _iframe.height = window.innerWidth;

          _iframe.contentWindow.postMessage(
            {
              type: "resize",
              width: window.innerWidth,
              height: window.innerHeight,
            },
            "*"
          );
          console.log(
            "resize w " + window.innerWidth - 160 + " h " + window.innerHeight
          );
        } else {
          _iframe.contentWindow.postMessage(
            {
              type: "resize",
              width: window.innerHeight,
              height: window.innerWidth + 160,
            },
            "*"
          );
          console.log(
            "resize w " + window.innerHeight + " h " + window.innerWidth
          );
        }
      }
    }
  } else {
    // android Chrome radi ne diraj
    _iframe.contentWindow.postMessage(
      {
        type: "resize",
        width:
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight,

        height:
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth,
      },
      "*"
    );
    console.log("resize h " + window.innerWidth + " w " + window.innerHeight);
  }
}
